import {createAsyncThunk} from '@reduxjs/toolkit'

import {createTicket} from 'airship/clients/zendesk/index'
import {CreateTicketResponse} from 'airship/clients/zendesk/types'
import {isRequestError} from 'airship/modules/request2/utils/RequestError'

import {Details} from './detailsSlice'

type RejectValue = {
  statusCode?: number
  message: string
}

export const createTicketThunk = createAsyncThunk<
  CreateTicketResponse,
  Details,
  {rejectValue: RejectValue}
>('createTicket', async (details, thunkAPI) => {
  try {
    return await createTicket(details)
  } catch (e) {
    if (isRequestError(e)) {
      return thunkAPI.rejectWithValue({
        statusCode: e.statusCode,
        message: e.message,
      })
    }
    throw e
  }
})
